export const URLS = {
  ksazain: 'ksa-zain',
  ksamobily: 'ksamobily',
}
